module.exports = __webpack_public_path__ + "static/media/long-arrow-right.0ad894b4.svg";